import React from "react";

import { Container } from "@magnetic/container";
import { Flex } from "@magnetic/flex";
import { Empty } from "@magnetic/icons";
import { Text } from "@magnetic/text";

import { Icon } from "src/components/icons";

import "./emptyContainer.scss";

type EmptyProps = {
  readonly className?: string;
  readonly text?: React.ReactNode;
  readonly additionalContent?: React.ReactNode;
  readonly title?: React.ReactNode;
  readonly fontSize?: string;
  readonly iconName?: string;
};

export const EmptyContainer = (props: EmptyProps) => {
  const {
    className = "",
    text = "No matches found",
    additionalContent,
    title = "",
    fontSize = "p4",
    iconName
  } = props;
  return (
    <Container
      className={`empty-container ${className}`}
      data-qa="empty-container"
    >
      <Flex
        align="center"
        className="mds-table-empty-state"
        direction="vertical"
        gap={4}
      >
        {iconName ? (
          <Icon name={iconName} classNames="icon-size" />
        ) : (
          <Empty.Info className="empty-icon" />
        )}
        {title && (
          <Text color="light" weight="bold" size="p1">
            {title}
          </Text>
        )}
        <Text color="light" size={fontSize}>
          {text}
        </Text>
        {additionalContent && additionalContent}
      </Flex>
    </Container>
  );
};
